export default __webpack_public_path__ + "static/media/005-cannon.9d1af33f.png";